(() => {
  const root = document.querySelector('[data-native-studio]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const $ = selector => root.querySelector(selector);
  const config = JSON.parse($('[data-config]').textContent);
  const canvas = $('canvas'), ctx = canvas.getContext('2d');
  const model = $('[data-model]'), zoom = $('#ns-zoom'), dialog = $('[data-dialog]');
  const state = { kind: 'phone', image: null, x: 0, y: 0, zoom: 1, angle: 0, frame: 0, version: 0, exportUrl: null, original: null, originalSize: null, package: null, busy: false, loading: false, touchEdit: false };
  const pointers = new Map();
  let touchGesture=null;
  function setTouchEdit(enabled) {
    touchGesture=null;
    state.touchEdit=Boolean(enabled && state.image && !state.loading);
    root.dataset.touchEdit=String(state.touchEdit);
    $('[data-touch-edit-toggle]').setAttribute('aria-pressed',String(state.touchEdit));
    for(const id of pointers.keys())if(canvas.hasPointerCapture(id))canvas.releasePointerCapture(id);
    pointers.clear();
  }
  $('[data-touch-edit-toggle]').addEventListener('click',()=>setTouchEdit(!state.touchEdit));
  window.addEventListener('blur',()=>setTouchEdit(false));
  root.addEventListener('keydown',e=>{if(e.key==='Escape')setTouchEdit(false);});
  const dielines = window.STICKSOO_NATIVE_DIELINES;
  if (!dielines?.models?.length) { $('[data-status]').textContent=config.text.template_error; return; }
  const phonePaths = new Map(Object.entries(dielines.geometries).map(([key,g])=>[key,{...g,path:new Path2D(g.path)}]));
  function currentTemplate() { return state.kind==='phone' ? dielines.models.find(m=>m.title===model.value) : null; }
  const camera = new Path2D();
  camera.roundRect(6,35,108,64,17);
  [[23,52,14],[23,82,14],[53,67,14],[99,50,6],[99,83,6],[99,67,1.6]].forEach(([x,y,r]) => { camera.moveTo(x+r,y); camera.arc(x,y,r,0,Math.PI*2); });
  function geometry() {
    return state.kind === 'phone' ? phonePaths.get(currentTemplate().geometry) : {path:camera,x:6,y:35,w:108,h:64};
  }
  function currentVariant() { return config.products[state.kind].variants.find(v=>v.title===model.value); }
  function updateSummary() {
    const product=config.products[state.kind], variant=currentVariant();
    $('[data-model-label]').textContent=model.value;
    canvas.setAttribute('aria-label',model.value+' '+product.name+'. '+config.text.canvas_label);
    root.querySelectorAll('[data-fit-note]').forEach(el=>el.textContent=state.kind==='phone'?config.text.phone_fit_note:config.text.fit_note);
    $('[data-model-availability]').textContent=variant?.available?'':config.text.preview_model;
    $('[data-kind-label]').textContent=product.name;
    $('[data-price]').textContent=variant?.price || config.text.preview_label;
    $('[data-set]').textContent=product.set;
    $('[data-review]').disabled=!state.image || state.loading;
    $('[data-touch-edit-toggle]').disabled=!state.image || state.loading;
  }
  function reset() { state.x=0;state.y=0;state.zoom=1;state.angle=0;sync(); }
  function sync() {
    state.x=Math.max(-.5,Math.min(.5,state.x));state.y=Math.max(-.5,Math.min(.5,state.y));
    state.angle=((state.angle+Math.PI*3)%(Math.PI*2))-Math.PI;
    $('#ns-angle').value=String(Math.round(state.angle*180/Math.PI));
    $('[data-angle-output]').textContent=Math.round(state.angle*180/Math.PI)+'°';
    if(state.image){
      const g=geometry(),base=imageFit(g)*state.zoom;
      const c=Math.cos(state.angle),s=Math.sin(state.angle);
      const covered=[[-1,-1],[-1,1],[1,-1],[1,1]].every(([sx,sy])=>{
        const dx=sx*g.w/2-state.x*g.w,dy=sy*g.h/2-state.y*g.h;
        return Math.abs(c*dx+s*dy)<=state.image.width*base/2+.1 && Math.abs(-s*dx+c*dy)<=state.image.height*base/2+.1;
      });
      $('[data-coverage]').hidden=covered;
    }
    zoom.value=String(Math.round(state.zoom*100));
    $('[data-zoom-output]').textContent=Math.round(state.zoom*100)+'%';
    if(!state.frame) state.frame=requestAnimationFrame(()=>{state.frame=0;draw();});
  }
  function imageFit(g) {
    return Math.max(g.w/state.image.width,g.h/state.image.height)*1.16;
  }
  function viewScale(w,h,g,workspace=true) {
    return Math.min(w*(workspace ? .82 : .70)/g.w,h*(workspace ? .80 : .86)/g.h);
  }
  function draw(target=ctx,workspace=true) {
    const w=target.canvas.width,h=target.canvas.height,g=geometry();
    const s=viewScale(w,h,g,workspace);
    target.clearRect(0,0,w,h);
    target.fillStyle='#f4f6f2';target.fillRect(0,0,w,h);
    target.save();target.translate(w/2,h/2);target.scale(s,s);target.translate(-g.x-g.w/2,-g.y-g.h/2);
    function paintImage(alpha=1){
      target.save();target.globalAlpha=alpha;
      const iw=state.image.width,ih=state.image.height;
      const base=imageFit(g);
      target.translate(g.x+g.w/2+state.x*g.w,g.y+g.h/2+state.y*g.h);
      target.rotate(state.angle);target.scale(base*state.zoom,base*state.zoom);
      target.drawImage(state.image,-iw/2,-ih/2);target.restore();
    }
    if(state.image && workspace)paintImage(.18);
    target.fillStyle='#e2e9df';target.fill(g.path,'evenodd');
    if(state.image){target.save();target.clip(g.path,'evenodd');paintImage();target.restore();}
    target.strokeStyle='#819181';target.lineWidth=1.3/s;target.stroke(g.path);target.restore();
  }
  function populateModels(preferred=model.value) {
    const choices=state.kind==='phone' ? dielines.models : config.products.camera.variants;
    model.replaceChildren(...choices.map(v=>new Option(v.title,v.title)));
    model.value=choices.some(v=>v.title===preferred)?preferred:choices[0].title;
  }
  root.querySelectorAll('[name="skin-type"]').forEach(radio=>radio.addEventListener('change',()=>{
    const title=model.value;
    setTouchEdit(false);state.kind=radio.value;canvas.height=state.kind==='camera'?480:900;
    populateModels(title);releasePackage();reset();updateSummary();
  }));
  model.addEventListener('change',()=>{setTouchEdit(false);releasePackage();reset();updateSummary();});
  $('[data-upload]').addEventListener('change',async event=>{
    const file=event.target.files?.[0];if(!file)return;setTouchEdit(false);
    const status=$('[data-status]');status.dataset.error='false';
    if(!['image/jpeg','image/png','image/webp'].includes(file.type)||file.size>20*1024*1024){status.textContent=config.text.file_error;status.dataset.error='true';event.target.value='';return;}
    const version=++state.version;
    status.textContent=config.text.loading;state.loading=true;updateSummary();
    const url=URL.createObjectURL(file);
    try{
      const img=new Image();img.src=url;await img.decode();
      if(version!==state.version)return;
      if(img.naturalWidth*img.naturalHeight>80000000)throw new Error('image_too_large');
      const reduced=document.createElement('canvas'),ratio=Math.min(1,2048/Math.max(img.naturalWidth,img.naturalHeight));
      reduced.width=Math.round(img.naturalWidth*ratio);reduced.height=Math.round(img.naturalHeight*ratio);
      reduced.getContext('2d').drawImage(img,0,0,reduced.width,reduced.height);
      state.original=file;state.originalSize=[img.naturalWidth,img.naturalHeight];state.image=reduced;$('[data-empty]').hidden=true;$('[data-adjust]').disabled=false;
      $('[data-upload-label]').textContent=config.text.replace;
      status.textContent=Math.min(img.naturalWidth,img.naturalHeight)<800?config.text.low_res:config.text.loaded;
      reset();updateSummary();
    }catch(error){if(version===state.version){status.textContent=config.text.decode_error;status.dataset.error='true';}}
    finally{if(version===state.version){state.loading=false;updateSummary();}URL.revokeObjectURL(url);event.target.value='';}
  });
  zoom.addEventListener('input',()=>{state.zoom=Number(zoom.value)/100;sync();});
  $('#ns-angle').addEventListener('input',e=>{state.angle=Number(e.target.value)*Math.PI/180;sync();});
  $('[data-rotate-left]').addEventListener('click',()=>{state.angle-=Math.PI/36;sync();});
  $('[data-rotate-right]').addEventListener('click',()=>{state.angle+=Math.PI/36;sync();});
  root.querySelectorAll('[data-move]').forEach(button=>button.addEventListener('click',()=>{
    const directions={left:[-.025,0],right:[.025,0],up:[0,-.025],down:[0,.025]};
    const [dx,dy]=directions[button.dataset.move];state.x+=dx;state.y+=dy;sync();
  }));
  $('[data-center]').addEventListener('click',()=>{state.x=0;state.y=0;sync();});
  $('[data-reset]').addEventListener('click',reset);
  function position(e){return {x:e.clientX,y:e.clientY};}
  function deltaToImage(dx,dy){
    const rect=canvas.getBoundingClientRect(),g=geometry();
    const renderScale=Math.min(rect.width/canvas.width,rect.height/canvas.height);
    const s=viewScale(canvas.width,canvas.height,g)*renderScale;
    state.x=Math.max(-.5,Math.min(.5,state.x+dx/(s*g.w)));
    state.y=Math.max(-.5,Math.min(.5,state.y+dy/(s*g.h)));
  }
  function touchPair(event) {
    if(event.touches.length!==2 || event.targetTouches.length!==2)return null;
    const pair=Array.from(event.targetTouches).sort((a,b)=>a.identifier-b.identifier);
    return {ids:pair.map(t=>t.identifier).join(':'),x:(pair[0].clientX+pair[1].clientX)/2,y:(pair[0].clientY+pair[1].clientY)/2,distance:Math.hypot(pair[1].clientX-pair[0].clientX,pair[1].clientY-pair[0].clientY)};
  }
  canvas.addEventListener('touchstart',event=>{
    touchGesture=null;
    if(state.touchEdit || !state.image || state.loading || !event.cancelable)return;
    const pair=touchPair(event);
    if(!pair)return;
    event.preventDefault();touchGesture=pair;
  },{passive:false});
  canvas.addEventListener('touchmove',event=>{
    if(state.touchEdit || !state.image || state.loading || !event.cancelable){touchGesture=null;return;}
    const pair=touchPair(event);
    if(!pair){touchGesture=null;return;}
    event.preventDefault();
    if(touchGesture && pair.ids===touchGesture.ids){
      if(touchGesture.distance>5)state.zoom=Math.max(.5,Math.min(3,state.zoom*pair.distance/touchGesture.distance));
      deltaToImage(pair.x-touchGesture.x,pair.y-touchGesture.y);sync();
    }
    touchGesture=pair;
  },{passive:false});
  ['touchend','touchcancel'].forEach(name=>canvas.addEventListener(name,()=>{touchGesture=null;},{passive:true}));
  canvas.addEventListener('pointerdown',e=>{if(!state.image || (e.pointerType!=='mouse' && !state.touchEdit))return;canvas.setPointerCapture(e.pointerId);pointers.set(e.pointerId,position(e));});
  canvas.addEventListener('pointermove',e=>{
    if(!pointers.has(e.pointerId)||!state.image)return;
    const previous=pointers.get(e.pointerId),next=position(e);
    if(pointers.size===2){
      const other=[...pointers.entries()].find(([id])=>id!==e.pointerId)[1];
      const before=Math.hypot(previous.x-other.x,previous.y-other.y),after=Math.hypot(next.x-other.x,next.y-other.y);
      if(before>5)state.zoom=Math.max(.5,Math.min(3,state.zoom*after/before));
      deltaToImage((next.x-previous.x)/2,(next.y-previous.y)/2);
    }else deltaToImage(next.x-previous.x,next.y-previous.y);
    pointers.set(e.pointerId,next);sync();
  });
  ['pointerup','pointercancel','lostpointercapture'].forEach(name=>canvas.addEventListener(name,e=>pointers.delete(e.pointerId)));
  canvas.addEventListener('keydown',e=>{
    if(!state.image)return;
    if(['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','+','=','-'].includes(e.key))e.preventDefault();else return;
    if(e.key==='ArrowLeft')state.x-=.01;if(e.key==='ArrowRight')state.x+=.01;
    if(e.key==='ArrowUp')state.y-=.01;if(e.key==='ArrowDown')state.y+=.01;
    if(e.key==='+'||e.key==='=')state.zoom=Math.min(3,state.zoom+.05);if(e.key==='-')state.zoom=Math.max(.5,state.zoom-.05);
    state.x=Math.max(-.5,Math.min(.5,state.x));state.y=Math.max(-.5,Math.min(.5,state.y));sync();
  });
  const fileFields=['Original image','Layout preview','Effect preview'];
  const cartRoot=window.Shopify?.routes?.root || '/';
  function png(c){return new Promise((resolve,reject)=>c.toBlob(b=>b?resolve(b):reject(new Error(config.text.export_error)),'image/png'));}
  async function originalArchive(file){
    // STORE ZIP: original file bytes are retained without image re-encoding.
    const bytes=new Uint8Array(await file.arrayBuffer()),name=new TextEncoder().encode(file.name.replace(/[\\/]/g,'_'));
    let crc=0xffffffff;
    for(const byte of bytes){crc^=byte;for(let n=0;n<8;n++)crc=(crc>>>1)^((crc&1)?0xedb88320:0);}
    crc=(crc^0xffffffff)>>>0;
    const local=new Uint8Array(30),central=new Uint8Array(46),end=new Uint8Array(22);
    const l=new DataView(local.buffer),c=new DataView(central.buffer),e=new DataView(end.buffer);
    l.setUint32(0,0x04034b50,true);l.setUint16(4,20,true);l.setUint16(6,0x800,true);l.setUint16(12,33,true);
    l.setUint32(14,crc,true);l.setUint32(18,bytes.length,true);l.setUint32(22,bytes.length,true);l.setUint16(26,name.length,true);
    c.setUint32(0,0x02014b50,true);c.setUint16(4,20,true);c.setUint16(6,20,true);c.setUint16(8,0x800,true);c.setUint16(14,33,true);
    c.setUint32(16,crc,true);c.setUint32(20,bytes.length,true);c.setUint32(24,bytes.length,true);c.setUint16(28,name.length,true);
    e.setUint32(0,0x06054b50,true);e.setUint16(8,1,true);e.setUint16(10,1,true);e.setUint32(12,central.length+name.length,true);e.setUint32(16,local.length+name.length+bytes.length,true);
    return new Blob([local,name,bytes,central,name,end],{type:'application/zip'});
  }
  function layoutCanvas(){
    const g=geometry(),k=imageFit(g)*state.zoom,iw=state.image.width,ih=state.image.height;
    const cx=g.x+g.w/2+state.x*g.w,cy=g.y+g.h/2+state.y*g.h;
    const c=Math.cos(state.angle),s=Math.sin(state.angle);
    const corners=[[-1,-1],[-1,1],[1,-1],[1,1]].map(([x,y])=>[cx+c*x*iw*k/2-s*y*ih*k/2,cy+s*x*iw*k/2+c*y*ih*k/2]);
    const pad=Math.max(g.w,g.h)*.025;
    const x=Math.min(g.x,...corners.map(p=>p[0]))-pad,y=Math.min(g.y,...corners.map(p=>p[1]))-pad;
    const w=Math.max(g.x+g.w,...corners.map(p=>p[0]))+pad-x,h=Math.max(g.y+g.h,...corners.map(p=>p[1]))+pad-y;
    const scale=2800/Math.max(w,h),out=document.createElement('canvas');
    out.width=Math.ceil(w*scale);out.height=Math.ceil(h*scale);
    const t=out.getContext('2d');t.fillStyle='#f4f6f2';t.fillRect(0,0,out.width,out.height);
    t.scale(scale,scale);t.translate(-x,-y);t.save();t.translate(cx,cy);t.rotate(state.angle);t.scale(k,k);t.drawImage(state.image,-iw/2,-ih/2);t.restore();
    t.lineWidth=5/scale;t.strokeStyle='#ffffff';t.stroke(g.path);t.lineWidth=2/scale;t.strokeStyle='#24533e';t.stroke(g.path);
    return {canvas:out,bounds:[x,y,w,h].map(v=>+v.toFixed(3))};
  }
  function releasePackage(){if(state.package)state.package.urls.forEach(URL.revokeObjectURL);state.package=null;}
  function updateAdd(){ $('[data-add]').disabled=state.busy || !state.package?.variant?.available || ![...root.querySelectorAll('[data-consent]')].every(el=>el.checked); }
  root.querySelectorAll('[data-consent]').forEach(el=>el.addEventListener('change',updateAdd));
  $('[data-review]').addEventListener('click',async()=>{
    if(!state.image||state.loading||state.busy)return;
    setTouchEdit(false);
    const signature=JSON.stringify([state.version,state.kind,model.value,state.x,state.y,state.zoom,state.angle]);
    $('[data-submit-status]').textContent=config.text.preparing;
    $('[data-saved]').hidden=true;$('[data-add]').hidden=!currentVariant()?.available;
    $('.ns-consents').hidden=!currentVariant()?.available;
    root.querySelectorAll('[data-consent]').forEach(el=>el.checked=false);
    if(!dialog.open)dialog.showModal();
    state.busy=true;updateAdd();
    try{
      if(state.package?.signature!==signature){
        releasePackage();
        const layout=layoutCanvas(),effect=document.createElement('canvas');
        effect.width=state.kind==='phone'?1920:2400;effect.height=state.kind==='phone'?2400:1600;
        draw(effect.getContext('2d'),false);
        const [layoutBlob,effectBlob,archive]=await Promise.all([png(layout.canvas),png(effect),originalArchive(state.original)]);
        state.package={signature,id:'NS-'+crypto.randomUUID(),variant:currentVariant() || {title:model.value,id:null,available:false,price:''},kind:state.kind,
          original:state.original,archive,layout:layoutBlob,effect:effectBlob,
          transform:JSON.stringify({v:2,template:currentTemplate()?.template || 'camera-illustrative-v1',sourceSHA256:currentTemplate()?.sourceSHA256,sourceSize:currentTemplate()?.sourceSize,geometry:currentTemplate()?.geometry,units:'source-pixels',x:+state.x.toFixed(6),y:+state.y.toFixed(6),zoom:state.zoom,angle:+(state.angle*180/Math.PI).toFixed(3),fit:1.16,original:state.originalSize,working:[state.image.width,state.image.height]}),
          bounds:JSON.stringify(layout.bounds),urls:[URL.createObjectURL(state.original),URL.createObjectURL(layoutBlob),URL.createObjectURL(effectBlob)]};
      }
      const pack=state.package;
      $('[data-review-image]').src=pack.urls[2];$('[data-layout-image]').src=pack.urls[1];
      $('[data-review-image]').alt=pack.variant.title+' '+config.products[pack.kind].name+' — effect preview';
      $('[data-layout-image]').alt=pack.variant.title+' '+config.products[pack.kind].name+' — full layout with artwork beyond all four edges';
      root.querySelectorAll('[data-download-file]').forEach((el,i)=>{el.href=pack.urls[i];el.download=i===0?pack.original.name:pack.id+(i===1?'-layout.png':'-effect.png');});
      $('[data-review-description]').textContent=config.products[pack.kind].name+' · '+pack.variant.title+(pack.variant.price?' · '+pack.variant.price:'');
      $('[data-design-id]').textContent=pack.id;
      $('[data-submit-status]').textContent=pack.variant.available?config.text.files_ready:config.text.preview_model;
    }catch(error){$('[data-submit-status]').textContent=config.text.export_error;}
    finally{state.busy=false;updateAdd();}
  });
  async function request(url,options={}){
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),90000);
    try{const r=await fetch(cartRoot+url,{credentials:'same-origin',...options,signal:controller.signal});const data=await r.json();if(!r.ok)throw new Error(typeof data.description==='string'?data.description:config.text.save_error);return data;}
    finally{clearTimeout(timer);}
  }
  function complete(item){return fileFields.every(key=>typeof item.properties?.[key]==='string' && /^https?:\/\//i.test(item.properties[key]) && !/\[object/.test(item.properties[key]));}
  function showSaved(item){
    const pack=state.package;
    if(!complete(item) || !pack || String(item.variant_id || item.id)!==String(pack.variant.id) || item.properties['Phone model']!==pack.variant.title || item.properties['Design ID']!==pack.id || item.properties['_Design transform']!==pack.transform || item.properties['_Layout bounds']!==pack.bounds)throw new Error(config.text.incomplete_files);
    $('[data-add]').hidden=true;$('[data-saved]').hidden=false;
    const box=$('[data-saved-files]');box.replaceChildren();
    fileFields.forEach(key=>{const a=document.createElement('a');a.href=item.properties[key];a.textContent=key==='Original image'?'Original image (ZIP)':key;a.target='_blank';a.rel='noopener';box.append(a);});
    $('[data-submit-status]').textContent=config.text.saved;
  }
  $('[data-add]').addEventListener('click',async()=>{
    if(state.busy || !state.package?.variant?.available || ![...root.querySelectorAll('[data-consent]')].every(el=>el.checked))return;
    const pack=state.package;state.busy=true;updateAdd();$('[data-submit-status]').textContent=config.text.saving;
    try{
      const cart=await request('cart.js');
      const existing=cart.items.find(item=>item.properties?.['Design ID']===pack.id);
      if(existing){showSaved(existing);return;}
      const form=new FormData();form.append('id',String(pack.variant.id));form.append('quantity','1');
      form.append('properties[Original image]',pack.archive,pack.id+'-original.zip');
      form.append('properties[Layout preview]',pack.layout,pack.id+'-layout.png');
      form.append('properties[Effect preview]',pack.effect,pack.id+'-effect.png');
      const properties={'Order type':'Native image customization','Design ID':pack.id,'Phone model':pack.variant.title,'Skin style':pack.kind==='phone'?'Phone Skin':'Camera Skin',
        '_Design transform':pack.transform,'_Layout bounds':pack.bounds,'_Native studio version':'2',
        'Image rights and order license':'Confirmed — limited to this order, CS-2026-09-15-SIMPLE-03',
        'Direct production authorization':'Agreed — production after payment and internal review; no separate proof',
        'Custom service terms':'Read and agreed — mandatory rights preserved',
        'Model and preview confirmation':'Confirmed','Custom policy version':'CS-2026-09-15-SIMPLE-03'};
      Object.entries(properties).forEach(([key,value])=>form.append('properties['+key+']',value));
      await request('cart/add.js',{method:'POST',body:form});
      const saved=await request('cart.js');const item=saved.items.find(item=>item.properties?.['Design ID']===pack.id);
      if(!item)throw new Error(config.text.save_error);showSaved(item);
    }catch(error){$('[data-submit-status]').textContent=error.name==='AbortError'?config.text.timeout:(error.message||config.text.save_error);}
    finally{state.busy=false;updateAdd();}
  });
  function closeReview(){if(!state.busy)dialog.close();}
  $('[data-close]').addEventListener('click',closeReview);$('[data-edit]').addEventListener('click',closeReview);
  dialog.addEventListener('cancel',e=>{if(state.busy)e.preventDefault();});
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)closeReview();}});
  window.addEventListener('beforeunload',e=>{if(state.busy){e.preventDefault();e.returnValue='';}});
  window.addEventListener('pagehide',releasePackage);
  populateModels();
  updateSummary();sync();
})();
